// extracted by mini-css-extract-plugin
module.exports = {"mainWindow":"Home_mainWindow__3q64-","sectionWrapper":"Home_sectionWrapper__3I8yj","tempBanner":"Home_tempBanner__Bie1N"};